var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.isMobile ? 'appM':'appPc', {'loginbg':_vm.$route.name == 'login'}],attrs:{"id":"app"}},[_c('h1',{staticClass:"title",staticStyle:{"display":"none"},attrs:{"id":"title"}},[_vm._v("网易云游戏")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }